import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import config from "@/config";
import DownloadLink from "@/components/DownloadLink";

export default function CommercialLawPage() {
  return (
    <div className="min-h-screen bg-background-50">
      {/* Header */}
      <motion.header
        className="sticky top-0 z-50 flex items-center justify-between bg-background-50/80 px-4 py-3 backdrop-blur-md"
        initial={{ y: -60, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.5, ease: [0.25, 0.4, 0.25, 1] }}
      >
        <Link
          to="/"
          className="flex items-center gap-1.5 text-sm text-foreground-400 transition-colors hover:text-foreground-200 whitespace-nowrap cursor-pointer"
        >
          <span className="flex h-7 w-7 items-center justify-center">
            <i className="ri-arrow-left-line text-lg" />
          </span>
          <span className="hidden sm:inline">トップページ</span>
        </Link>
        <span className="text-sm font-bold text-foreground-100">特定商取引法に基づく表記</span>
        <div className="w-20" />
      </motion.header>

      {/* Content */}
      <main className="mx-auto max-w-2xl px-4 py-8 pb-32 sm:px-6 sm:py-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <h1 className="font-heading text-2xl font-bold text-foreground-100 sm:text-3xl">
            特定商取引法に基づく表記
          </h1>

          <div className="mt-8 overflow-hidden rounded-xl border border-background-200/50">
            <table className="w-full text-sm text-foreground-300 sm:text-base">
              <tbody>
                {[
                  {
                    label: "メールアドレス",
                    value: config.siteSupport,
                  },
                  {
                    label: "販売URL",
                    value: config.siteLink,
                  },
                  {
                    label: "販売価格",
                    value: "各商品の購入ページに表示（消費税込みの総額表示）",
                  },
                  {
                    label: "商品代金以外の必要料金",
                    value: (
                      <>
                        インターネット接続に必要な通信料はお客様のご負担となります。
                        <br />
                        なお、通信料はお客様がご契約されている各通信事業者によって異なります。
                      </>
                    ),
                  },
                  {
                    label: "支払方法",
                    value: (
                      <>
                        Apple ID決済（App Store）
                        <br />
                        Google Play決済（Google Playストア）
                        <br />
                        クレジットカード（Visa / Mastercard / JCB / American Express）
                      </>
                    ),
                  },
                  {
                    label: "支払時期",
                    value: (
                      <>
                        購入手続き完了時にお支払いが確定します。
                        <br />
                        定期購入（サブスクリプション）の場合は、各決済事業者の規約に従います。
                      </>
                    ),
                  },
                  {
                    label: "商品の引渡時期",
                    value: "購入手続き完了後、即時にサービスのご利用が可能となります。",
                  },
                  {
                    label: "返品・キャンセルについて",
                    value: (
                      <>
                        デジタルコンテンツの特性上、購入後の返品・返金は原則としてお受けできません。
                        <br />
                        ただし、法令に定める場合またはサービスに重大な瑕疵がある場合はこの限りではありません。
                        <br />
                        アプリストア経由の購入については、各ストアの返金ポリシーに従います。
                      </>
                    ),
                  },
                  {
                    label: "動作環境",
                    value: (
                      <>
                        ※一部の端末・OSバージョンでは正常に動作しない場合があります。
                      </>
                    ),
                  },
                  {
                    label: "定期購入（サブスクリプション）",
                    value: (
                      <>
                        ・プレミアム会員（月額）：1,480円（税込）/月
                        <br />
                        ・プレミアム会員（年額）：14,800円（税込）/年
                        <br />
                        ・VIP会員（月額）：3,980円（税込）/月
                        <br />
                        <br />
                        定期購入は、期間終了の24時間前までにキャンセルされない限り自動更新されます。
                        <br />
                        キャンセルは各アプリストアの設定画面から行えます。
                      </>
                    ),
                  },
                  {
                    label: "返品・交換の条件",
                    value: (
                      <>
                        デジタルコンテンツの性質上、購入後の交換はできません。
                        <br />
                        購入前に商品内容を十分ご確認のうえ、お手続きください。
                      </>
                    ),
                  },
                ].map((row, i) => (
                  <tr
                    key={i}
                    className={i % 2 === 0 ? "bg-background-100/40" : ""}
                  >
                    <th className="w-40 whitespace-nowrap border-r border-background-200/50 px-4 py-3 text-left text-xs font-bold text-foreground-100 sm:w-56 sm:px-6 sm:py-4 sm:text-sm">
                      {row.label}
                    </th>
                    <td className="px-4 py-3 text-xs leading-relaxed text-foreground-300 sm:px-6 sm:py-4 sm:text-sm">
                      {row.value}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <p className="mt-6 text-xs text-foreground-500">
            ※ 本表記に記載のない事項につきましては、利用規約をご確認ください。
          </p>
        </motion.div>
      </main>

      {/* Fixed bottom CTA */}
      <motion.div
        className="fixed bottom-0 left-0 right-0 z-40 border-t border-background-200/50 bg-background-50/95 px-4 py-3 backdrop-blur-md"
        initial={{ y: 80, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.5, duration: 0.4, ease: [0.25, 0.4, 0.25, 1] }}
      >
        <div className="mx-auto max-w-2xl">
          <DownloadLink
            downloadType="button"
            className="flex w-full items-center justify-center gap-2 rounded-xl bg-primary-500 py-3 text-sm font-bold text-white transition-colors hover:bg-primary-600 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-download-line text-3xl" />
            アプリを今すぐダウンロード
            <br/>
            無料で始められます
          </DownloadLink>
        </div>
      </motion.div>
    </div>
  );
}